import { createFeatureSelector } from '@ngrx/store';

import { type ElementsState } from './elements/elements.state';
import { type RuntimeState } from './runtime/runtime.state';

export const ENGINE_FEATURE_KEY = 'engine';

/**
 * The part of the `engine` feature slice this library declares: the element tree, and the
 * state a running app reads and writes.
 *
 * It is a base, not the whole slice. `runtime/engine/feature` extends it with the editor's
 * authoring slices — undo/redo history, AI, target workflow — into `EngineState`, which is the
 * shape actually registered with the store. Runtime code depends on the base so that it does
 * not depend on authoring state; the two converge when the authoring slices move to
 * `scope:dashboard`.
 */
export type EngineStateBase = ElementsState & RuntimeState;

/**
 * Reads the `engine` feature slice as {@link EngineStateBase}.
 *
 * The feature library declares a second feature selector over the same slice, typed with the
 * whole shape. Both return the identical state object, so selectors composed from either see
 * the same values.
 */
export const getEngineStateBase = createFeatureSelector<EngineStateBase>(ENGINE_FEATURE_KEY);
